module.exports = __webpack_public_path__ + "static/media/map-mobile-marker-5.d6432a95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/map-mobile-marker-5.svg
// module id = 689
// module chunks = 6